export default __webpack_public_path__ + "media/images/instagram-0c988e863f16ea452d9a878cc2eeede7.svg";